module.exports = __webpack_public_path__ + "img/zoom-in.dbe7a733.svg";